function parseEditModeFloat(value) {
  const parsedFloat = parseFloat(value, 10);
  if (Number.isNaN(parsedFloat)) {
    return '';
  }
  if (!value.includes('.') || value.indexOf('.') === value.length - 1) {
    return value;
  }
  // return truncated after 1 decimal point
  return value.substring(0, value.indexOf('.') + 2);
}

function sanitizeFloats(data) {
  if (Number.isNaN(parseFloat(data))) {
    return 0;
  }
  return parseFloat(data);
}

export { parseEditModeFloat, sanitizeFloats };
